import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../lib/api/client.js";
import type { Ruolo } from "@taras/contracts";

interface MeResponse {
  id: string;
  username: string;
  nome: string;
  cognome: string;
  ruolo: Ruolo;
  must_change_password: boolean;
  mfa_enabled: boolean;
}

export function RequireAuth() {
  const location = useLocation();

  const { data, isLoading } = useQuery<MeResponse>({
    queryKey: ["auth", "me"],
    queryFn: () => apiClient.get<MeResponse>("/api/v1/auth/me"),
    retry: false,
  });

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="animate-spin h-8 w-8 rounded-full border-4 border-blue-600 border-t-transparent" />
      </div>
    );
  }

  if (!data) {
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  }

  return <Outlet />;
}
